var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-4be5f8eb"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "flex items-center text-black text-lg" };
var _hoisted_2 = { class: "sm:col-span-2" };
var _hoisted_3 = {
    for: "citta",
    class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
    style: { "display": "inline-block" }
};
var _hoisted_4 = {
    role: "status",
    style: { "display": "inline-block", "margin-left": "2%" }
};
var _hoisted_5 = ["aria-hidden"];
var _hoisted_6 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("path", {
    d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
    fill: "currentColor"
}, null, -1); });
var _hoisted_7 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("path", {
    d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
    fill: "currentFill"
}, null, -1); });
var _hoisted_8 = [
    _hoisted_6,
    _hoisted_7
];
var _hoisted_9 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "sr-only" }, "Loading...", -1); });
var _hoisted_10 = { class: "m-b-15" };
var _hoisted_11 = { class: "relative" };
var _hoisted_12 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", {
    style: { "position": "absolute" },
    class: "inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
}, [
    /*#__PURE__*/ _createElementVNode("svg", {
        "aria-hidden": "true",
        class: "w-5 h-5 text-gray-500 dark:text-gray-400",
        fill: "currentColor",
        viewBox: "0 0 512 512",
        xmlns: "http://www.w3.org/2000/svg",
        id: "search"
    }, [
        /*#__PURE__*/ _createElementVNode("path", { d: "M448.3 424.7L335 311.3c20.8-26 33.3-59.1 33.3-95.1 0-84.1-68.1-152.2-152-152.2-84 0-152 68.2-152 152.2s68.1 152.2 152 152.2c36.2 0 69.4-12.7 95.5-33.8L425 448l23.3-23.3zM120.1 312.6c-25.7-25.7-39.8-59.9-39.8-96.3s14.2-70.6 39.8-96.3 59.9-40 96.2-40c36.3 0 70.5 14.2 96.2 39.9s39.8 59.9 39.8 96.3-14.2 70.6-39.8 96.3c-25.7 25.7-59.9 39.9-96.2 39.9-36.3.1-70.5-14.1-96.2-39.8z" })
    ])
], -1); });
var _hoisted_13 = ["placeholder"];
var _hoisted_14 = ["selected", "value"];
var _hoisted_15 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_16 = { class: "m-b-15" };
var _hoisted_17 = {
    for: "Via di residenza",
    class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_18 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_19 = { class: "m-b-15" };
var _hoisted_20 = {
    for: "Telephone",
    class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_21 = { class: "text-red-500 mb-2 w-full" };
import { ref, onMounted, reactive } from "vue";
import debounce from "@/utils/debounce";
import { patientStore } from '@/store/patient';
import { storeToRefs } from 'pinia';
import { getGeoLocation } from "../../../../EshJSLib/services/geoService";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { Modal } from "flowbite-vue";
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
export default /*#__PURE__*/ _defineComponent({
    __name: 'pazienteAggiuntiveEdit',
    emits: ['cancel'],
    setup: function (__props, _a) {
        var _this = this;
        var emit = _a.emit;
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var isOpen = ref(false);
        var isOpenNas = ref(false);
        var cittaRezSc = ref(false);
        var error = ref(false);
        var currentCityQuery = ref('');
        var cityList = ref([]);
        var errors = ref([]);
        var alertModal = ref(null);
        var showLoading = ref(false);
        var isShowModal = reactive({
            mobileNumberError: false,
        });
        onMounted(function () {
            patient.value.status = "update";
        });
        function validateFields() {
            errors.value = [];
            errors.value[1] = !patient.value.user.contact_detail.contatto_indirizzo ? 'Questo campo è obbligatorio' : '';
            errors.value[0] = currentCityQuery.value != patient.value.user.contact_detail.comune_residenza && currentCityQuery.value != "" ? 'Seleziona una delle città' : '';
            errors.value[0] = !patient.value.user.contact_detail.comune_residenza ? 'Questo campo è obbligatorio' : '';
            errors.value[2] = !validatePhoneNumber() ? 'Il numero di telefono non è valido!' : '';
            return errors.value.filter(function (error) { return error != ''; }).length == 0;
        }
        function updateValue() {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var userInput;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localStorage.setItem('patient', JSON.stringify(patient.value));
                            patient.value.status = "update";
                            return [4 /*yield*/, ((_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal("Salvare le modifiche ? ", true))];
                        case 1:
                            userInput = _b.sent();
                            if (userInput) {
                                showLoading.value = true;
                                store.saveSchedaPaziente()
                                    .then(function () {
                                    var _a;
                                    showLoading.value = false;
                                    (_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal("Salvato con successo! ", false).then(function () { return emit('cancel'); });
                                    store.refreshScheda(store.patient.id_paziente);
                                })
                                    .catch(function (res) {
                                    var _a;
                                    showLoading.value = false;
                                    (_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false);
                                    store.refreshScheda(store.patient.id_paziente);
                                });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        function validatePhoneNumber() {
            if (!patient.value.user.contact_detail.contatto_telefono)
                return false;
            //eslint-disable-next-line
            var regex1 = /([0-9\s\-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
            if (!regex1.test(patient.value.user.contact_detail.contatto_telefono.replaceAll(/\s/g, ''))) {
                return false;
            }
            return true;
        }
        function checkContatto() {
            errors.value = [];
            var val = validateFields();
            if (!val) {
                return false;
            }
            else {
                updateValue();
            }
        }
        function switchVis(e) {
            isOpen.value = false;
            error.value = false;
            if (e.target == null) {
                return;
            }
            currentCityQuery.value = e.target.value;
        }
        var checkCurrentTown = debounce(function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cittaRezSc.value = true;
                        isOpenNas.value = false;
                        return [4 /*yield*/, getGeoLocation(currentCityQuery.value)];
                    case 1:
                        response = _a.sent();
                        cityList.value = response;
                        isOpen.value = true;
                        cittaRezSc.value = false;
                        return [2 /*return*/];
                }
            });
        }); }, 700);
        return function (_ctx, _cache) {
            var _component_LoadingComponent = _resolveComponent("LoadingComponent");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Modal), {
                    onClose: _cache[8] || (_cache[8] = function ($event) { return (_ctx.$emit('cancel')); })
                }, {
                    header: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('Aggiorna') + ' ' + _ctx.$t('informazioni recapiti')), 1)
                    ]; }),
                    body: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("Città di residenza ")), 1),
                            _withDirectives(_createElementVNode("div", _hoisted_4, [
                                (_openBlock(), _createElementBlock("svg", {
                                    "aria-hidden": !_unref(cittaRezSc),
                                    class: "w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600",
                                    viewBox: "0 0 100 101",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg"
                                }, _hoisted_8, 8, _hoisted_5)),
                                _hoisted_9
                            ], 512), [
                                [_vShow, _unref(cittaRezSc)]
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _hoisted_12,
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        id: "citta",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return (_isRef(currentCityQuery) ? (currentCityQuery).value = $event : currentCityQuery = $event); }),
                                        onKeyup: _cache[1] || (_cache[1] =
                                            //@ts-ignore
                                            function () {
                                                var args = [];
                                                for (var _i = 0; _i < arguments.length; _i++) {
                                                    args[_i] = arguments[_i];
                                                }
                                                return (_unref(checkCurrentTown) && _unref(checkCurrentTown).apply(void 0, args));
                                            }),
                                        onClick: _cache[2] || (_cache[2] = function ($event) {
                                            _isRef(isOpen) //@ts-ignore
                                                ? isOpen.value = true : isOpen = true;
                                            _isRef(isOpenNas) //@ts-ignore
                                                ? isOpenNas.value = false : isOpenNas = false;
                                        }),
                                        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                        placeholder: _unref(patient).user.contact_detail.comune_residenza
                                    }, null, 40, _hoisted_13), [
                                        [_vModelText, _unref(currentCityQuery)]
                                    ])
                                ]),
                                _withDirectives(_createElementVNode("select", {
                                    onChange: _cache[3] || (_cache[3] = function ($event) { return (switchVis($event)); }),
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((_unref(patient).user.contact_detail.comune_residenza) = $event); }),
                                    size: "10",
                                    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cityList), function (item) {
                                        return (_openBlock(), _createElementBlock("option", {
                                            selected: item.city,
                                            key: item.city,
                                            value: item.city
                                        }, _toDisplayString(item.city), 9, _hoisted_14));
                                    }), 128))
                                ], 544), [
                                    [_vShow, _unref(isOpen) === true],
                                    [_vModelSelect, _unref(patient).user.contact_detail.comune_residenza]
                                ]),
                                _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(errors)[0]), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("Via di residenza")), 1),
                            _withDirectives(_createElementVNode("input", {
                                class: _normalizeClass([{ 'border-red-500': _unref(errors)[1] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"]),
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((_unref(patient).user.contact_detail.contatto_indirizzo) = $event); }),
                                type: "text",
                                id: "residenza",
                                required: ""
                            }, null, 2), [
                                [_vModelText, _unref(patient).user.contact_detail.contatto_indirizzo]
                            ]),
                            _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(errors)[1]), 1)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("Telephone")), 1),
                            _createVNode(_unref(VueTelInput), {
                                mode: "international",
                                inputOptions: { placeholder: 'Inserisci il numero di telefono' },
                                modelValue: _unref(patient).user.contact_detail.contatto_telefono,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((_unref(patient).user.contact_detail.contatto_telefono) = $event); }),
                                defaultCountry: 'IT',
                                disabledFetchingCountry: false,
                                disabled: false,
                                disabledFormatting: false,
                                enabledCountryCode: false
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(errors)[2]), 1)
                        ])
                    ]; }),
                    footer: _withCtx(function () { return [
                        _createElementVNode("button", {
                            id: "submitRecapiti",
                            onClick: _cache[7] || (_cache[7] = function ($event) { return (checkContatto()); }),
                            class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        }, _toDisplayString(_ctx.$t("Salva")), 1)
                    ]; }),
                    _: 1
                }),
                _createVNode(AlertModal, {
                    ref_key: "alertModal",
                    ref: alertModal
                }, null, 512),
                (showLoading.value)
                    ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
